import type {
  SearchFilterCondition,
  SearchFilterValue,
} from 'lib-shared-types-api';
import { useMemo } from 'react';

import { ConditionFieldDate } from './components/date/conditionFieldDate';
import { ConditionFieldDuration } from './components/duration/conditionFieldDuration';
import {
  ConditionFieldAgents,
  ConditionFieldChannel,
  ConditionFieldCompany,
  ConditionFieldContacts,
  ConditionFieldDirection,
  ConditionFieldId,
  ConditionFieldQueue,
  ConditionFieldStatus,
  ConditionFieldTags,
  ConditionFieldUserType,
} from './components/select/conditionFieldSelect';

/** Represents the props passed to a filter condition field. */
export type ConditionFieldProps = {
  /** The current filter condition. */
  condition: SearchFilterCondition;
  /** The placeholder to show in the filter component input. */
  placeholder?: string;
  /** Whether the filter component input is disabled. */
  disabled?: boolean;
  /** The callback called when the value of the filter component input changes. */
  onChange: (values: SearchFilterValue[]) => void;
  /** The callback called when an error occurs in a filter component. */
  onError?: (error: string) => void;
};

export const ConditionField = (props: ConditionFieldProps): JSX.Element => {
  const Component = useMemo(() => {
    switch (props.condition.field) {
      case 'numeric_id':
        return ConditionFieldId;
      case 'status':
        return ConditionFieldStatus;
      case 'initial_direction':
        return ConditionFieldDirection;
      case 'initial_channel':
        return ConditionFieldChannel;
      case 'queue_id':
        return ConditionFieldQueue;
      case 'agent_id':
        return ConditionFieldAgents;
      case 'requested_by':
        return ConditionFieldContacts;
      case 'tags':
        return ConditionFieldTags;
      case 'company_id':
        return ConditionFieldCompany;
      case 'user_type':
        return ConditionFieldUserType;
      case 'duration':
        return ConditionFieldDuration;
      default:
        return ConditionFieldDate;
    }
  }, [props.condition.field]);

  return <Component {...props} />;
};
